import Service from './abstract';

export class FaceLiveness extends Service {
    constructor() {
        super('cuotitasstores')
    }

    // point to local cuotitasstores microservice
    // get baseURL() {
    //     return `http://localhost:64055`
    // }

    async createSession() {
        return this.post('/faceliveness/create-session');
    }

    async postSessionResults(sessionId, { requestId, document, gender, selfieUrl }) {
        const body = {
            requestId,
            document: String(document),
            gender
        };
        if (selfieUrl) {
            body.selfieUrl = selfieUrl;
        }
        return this.post(`/faceliveness/session-results/${sessionId}`, { data: body });
    }

    async updateAttempts(requestId) {
        return this.put(`/faceliveness/requests/${requestId}/attempts`);
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new FaceLiveness()
